import ReactMarkdown from 'react-markdown'

import clsx from 'clsx'

import remarkGfm from 'remark-gfm'

interface Props {
  children: string
  size?: 12 | 13 | 14
}

// AI生成テキスト等のMarkdown文字列を、デザインシステムの配色・字送りで表示する。
// 生HTMLはデフォルトで無効（react-markdown はプラグイン無しでは HTML を描画しない）ため安全。
// GFM（表・打ち消し線・自動リンク・タスクリスト）は remark-gfm で対応する。
const Markdown = ({ children, size = 14 }: Props) => {
  const sizeClass = size == 12 ? 'text-size-12' : size == 13 ? 'text-size-13' : 'text-size-14'

  return (
    <div
      className={clsx(
        sizeClass,
        'text-primary leading-[150%] break-words',
        // 段落
        '[&_p]:my-2 [&_p:first-child]:mt-0 [&_p:last-child]:mb-0',
        // 強調
        '[&_del]:line-through [&_em]:italic [&_strong]:font-bold',
        // 見出し（インサイト用途を想定し控えめに）
        '[&_h1]:text-size-16 [&_h1]:mt-3 [&_h1]:mb-2 [&_h1]:font-bold',
        '[&_h2]:text-size-16 [&_h2]:mt-3 [&_h2]:mb-2 [&_h2]:font-bold',
        '[&_h3]:text-size-14 [&_h3]:mt-3 [&_h3]:mb-1 [&_h3]:font-bold',
        '[&_h4]:text-size-14 [&_h4]:mt-2 [&_h4]:mb-1 [&_h4]:font-bold',
        '[&_:is(h1,h2,h3,h4):first-child]:mt-0',
        // リスト
        '[&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5',
        '[&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5',
        '[&_li]:my-1 [&_li>ol]:my-1 [&_li>ul]:my-1',
        // リンク
        '[&_a]:text-link [&_a]:underline [&_a]:underline-offset-2',
        // コード
        '[&_code]:bg-surface-secondary [&_code]:rounded [&_code]:px-1 [&_code]:py-0.5 [&_code]:text-[0.9em]',
        '[&_pre]:bg-surface-secondary [&_pre]:my-2 [&_pre]:overflow-x-auto [&_pre]:rounded-lg [&_pre]:p-3',
        '[&_pre_code]:bg-transparent [&_pre_code]:p-0',
        // 引用
        '[&_blockquote]:border-border-input [&_blockquote]:text-secondary [&_blockquote]:my-2 [&_blockquote]:border-l-2 [&_blockquote]:pl-3',
        // 区切り線
        '[&_hr]:border-border-input [&_hr]:my-3',
        // 表（GFM）
        '[&_table]:my-2 [&_table]:w-full [&_table]:border-collapse',
        '[&_th]:border-border-input [&_th]:border [&_th]:px-2 [&_th]:py-1 [&_th]:text-left [&_th]:font-bold',
        '[&_td]:border-border-input [&_td]:border [&_td]:px-2 [&_td]:py-1 [&_td]:align-top'
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </div>
  )
}

export default Markdown
